import { Directive, ElementRef, Input, OnInit, OnChanges, Renderer2, HostBinding, SimpleChanges } from '@angular/core';

@Directive({ selector: '[image-back]' })
export class ImageBack implements OnInit {

    @Input('image-back') imageArray: Array<any> = [];
    @Input() name: string;
    @Input() size: string;

    constructor(private el: ElementRef, private renderer: Renderer2) {
    }

    ngOnInit() {

    }

    ngOnChanges(changes: SimpleChanges) {
        this.setBackgroundImage();
    }

    setBackgroundImage() {
        if (!this.el || this.imageArray.length < 1) {
            return
        }

        let image = this.imageArray.find((i) => { return this.name === i.name || this.size === i.size });
        if (image) {
            this.renderer.setStyle(this.el.nativeElement, "backgroundImage", 'url(' + image.url + ')');
        }
    }
}



// WEBPACK FOOTER //
// ./src/angular-shared-features/feature/shared-directives/image-back.directive.ts